<template>
	<th :style="[styleWidth]">
		<div class="flex">
			<span
				class="flex-1 ms-th-title"
				:class="[`text-${col.align}`, col.cssClass]"
				v-tooltip="col.tooltip"
				>{{ col.title }}</span
			>
			<div class="ms-resize" @mousedown="resizeOn"></div>
		</div>
	</th>
</template>
<script>
export default {
	name: 'msTh',
	props: {
		col: {},
		data: {},
	},
	created() {
		const me = this;
		me.widthx = me.col.width;
		me.autoResizex = me.col.autoResize;
		me.minWidthx = me.col.width;
	},
	computed: {
		styleWidth() {
			const me = this;
			if (me.$el) {
				me.col.width = me.$el.offsetWidth;
			}
			if (me.autoResizex) {
				return {
					'min-width': me.widthx + 'px',
				};
			}
			return {
				width: me.widthx + 'px',
				'min-width': me.widthx + 'px',
			};
		},
	},
	watch: {
		cursorX() {
			const me = this;
			let offsetX = this.resizeX - this.cursorX;
			if (this.defaultwidth - offsetX >= this.minWidthx) {
				this.widthx = this.defaultwidth - offsetX;
			} else {
				this.widthx = this.minWidthx;
			}
			me.col.width = me.$el.offsetWidth;
		},
	},
	data() {
		return {
			cursorX: 0,
			widthx: 0,
			autoResizex: false,
		};
	},
	methods: {
		//Bắt đầu co kéo cột
		resizeOn(event) {
			const me = this;
			this.$nextTick(() => {
				this.defaultwidth = this.$el.offsetWidth;
			});
			this.resizeX = event.screenX;
			me.$emit('resizeOn', this.col);
			document.addEventListener('mousemove', this.mousemove);
		},
		//Di chuyển co kéo cột
		mousemove(e) {
			const me = this;
			me.cursorX = e.screenX;
			me.$emit('resizeMove', this.col);
			if (!me.isResizeActive) {
				me.isResizeActive = true;
				document.addEventListener('mouseup', me.resizeOff);
			}
		},
		//Ngừng co kéo cột
		resizeOff() {
			const me = this;
			me.col.width = me.$el.offsetWidth;
			me.$emit('resizeOff', me.col);
			document.removeEventListener('mousemove', me.mousemove);
			me.closeResizeOff();
			me.isResizeActive = false;
		},
		closeResizeOff() {
			document.removeEventListener('mouseup', this.resizeOff);
		},
		//Update lại động rộng của cột
		updateColWidth() {
			const me = this;
			if (me.$el) {
				me.widthx = me.$el.offsetWidth;
				me.autoResizex = false;
			}
		},
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msGridViewer.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msGridViewer.scss';
}
</style>